<template>
  <li class="recipe">
    <a @click="goToRoute()">
      <div class="image">
        <img src="/image/reheat.jpg" alt="" />
      </div>
      <h2 class="title">{{ title }}</h2>
    </a>
  </li>
</template>
<script>
/* eslint-disable no-useless-escape */

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    goToRoute() {
      this.$router.push({ path: '/reheat/' });
    },
  },
};
</script>
<style lang="scss" scoped>
.recipe {
  width: 100%;
  list-style-type: none;
  text-align: left;
  margin: 0 0 30px 0;

  a {
    cursor: pointer;
  }
}

.image {
  width: 80%;
  margin: 0 0 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
  @include tablet {
    width: 100%;
  }
}

h2.title {
  font-family: $national-condensed-bold;
  font-size: 25px;
  color: #000000;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  @include tablet {
    font-size: 30px;
  }
}
</style>
